import PlayerInterface from 'interfaces/players-data-interfaces/player-interface';

export default class SubstitutePlayersConverter {
    static convertToMode(players: Array<PlayerInterface>, mode: string): Array<PlayerInterface> {
        return players.map((player) => {
            const playerInMode = cp(player);
            playerInMode.setMode(mode);

            return playerInMode;
        });
    }
}
